import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        name: {
            component: LinkTitleComponent,
        },
    },
    filterable: [],
    sortable: [],
    toolbar: [
        {
            name: 'create',
        },
    ],
    pagination: true,
    searchable: true,
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
        // {
        //     name: 'active',
        //     primary: true,
        //     component: ActiveSwitchActionComponent,
        // },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.layouts.js